import goTo from "../goTo";

export default async function saveUserAuth(data) {
  if (data) {
    localStorage.setItem("forever-kite-token", data.token);
    localStorage.setItem("forever-kite-userId", data.userId);

    window.doInitialLoad().then(() => {
      goTo("/")();
    });
  }
}
